'use client';

import { createContext, useContext } from 'react';

export const NativeLayoutContext = createContext(false);

export function useNativeLayout() {
  return useContext(NativeLayoutContext);
}
